import { AppSurfaceDefinitionVersion } from "./spec.ts";
export const SurfaceRuntimeLimits = Object.freeze({ definitionBytes: 262144, responseBytes: 1048576, rowsPerSource: 200, queryRowsPerSource: 100,
  totalRows: 800, renderedCells: 20000, concurrentSourceReads: 4, sources: 16, widgets: 24, recordPanels: 16, inboxPanels: 3,
  relationPaths: 4, relationDepth: 2, childrenPerRelation: 20, fields: 100, actions: 32, navigationEntries: 64,
  minimumPollSeconds: 15, calendarWindowDays: 93, visibleCalendarEvents: 200,
  renderers: { TABLE: 1, FORM: 1, RECORD: 1, KANBAN: 1, INBOX: 1, DASHBOARD: 1, TIMELINE: 1, CALENDAR: 1 },
  acceptance: { p95InteractiveMs: 2000, p95ColdInteractiveMs: 15000, maxMainThreadTaskMs: 50, maxDomNodes: 2000, axeSerious: 0, axeCritical: 0,
    desktopWidth: 1440, desktopHeight: 900, mobileWidth: 390, mobileHeight: 844 },
});
/** Compiler/loader gate, not truncation. An oversized result is rejected as a whole. */
export function checkSurfaceRuntimeBudget(input: unknown, usage: { responseBytes: number; renderedCells: number; rowsBySource: Readonly<Record<string, number>> }): string[] {
  const parsed = AppSurfaceDefinitionVersion.safeParse(input);
  if (!parsed.success) return ["SURFACE_DEFINITION_INVALID"];
  let bytes: number;
  try { bytes = new TextEncoder().encode(JSON.stringify(parsed.data)).byteLength; }
  catch { return ["SURFACE_DEFINITION_INVALID"]; }
  const errors = new Set<string>(), definition = parsed.data;
  if (bytes > SurfaceRuntimeLimits.definitionBytes) errors.add("SURFACE_DEFINITION_TOO_LARGE");
  if (![usage.responseBytes, usage.renderedCells].every(n => Number.isSafeInteger(n) && n >= 0)) errors.add("SURFACE_USAGE_INVALID");
  if (usage.responseBytes > SurfaceRuntimeLimits.responseBytes) errors.add("SURFACE_RESPONSE_TOO_LARGE");
  if (usage.renderedCells > SurfaceRuntimeLimits.renderedCells) errors.add("SURFACE_CELL_LIMIT");
  let total = 0;
  for (const [id, rows] of Object.entries(usage.rowsBySource)) {
    const source = definition.dataSources.find(s => s.id === id);
    if (!source || !Number.isSafeInteger(rows) || rows < 0) { errors.add("SURFACE_SOURCE_USAGE_INVALID"); continue; }
    const cap = Math.min(source.maxRows, source.kind === "PROJECT_QUERY" ? SurfaceRuntimeLimits.queryRowsPerSource : SurfaceRuntimeLimits.rowsPerSource);
    if (rows > cap) errors.add("SURFACE_ROW_LIMIT");
    total += rows;
  }
  if (total > SurfaceRuntimeLimits.totalRows) errors.add("SURFACE_TOTAL_ROW_LIMIT");
  return [...errors];
}
